import React from "react";

import HeroSection from "./HeroSection";
import Highlights from "./Highlights";
import Features from "./Features";

import {
  ConditionTextContainer,
  StyledConditionsLink,
  StyledLeftSection,
} from "./style";

const LeftSection = ({ data = {} }) => {
  const { hero, highlights, features, conditions } = data;

  const ConditionsLink = conditions && (
    <ConditionTextContainer>
      <StyledConditionsLink
        variant="paragraph3"
        dangerouslySetInnerHTML={{ __html: conditions }}
      />
    </ConditionTextContainer>
  );

  return (
    <StyledLeftSection>
      <HeroSection {...hero} />
      <Highlights {...highlights} />
      <Features {...features} />
      {ConditionsLink}
    </StyledLeftSection>
  );
};

export default LeftSection;
